module.exports = __webpack_public_path__ + "static/img/30.ea3f1aa5.png";